<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label for="isActive" class="col-sm-4 col-form-label  text-capitalize-first">
            {{ form.isActive ? helper.trans('requisites.active') : helper.trans('requisites.inactive') }}
          </label>
          <div class="col-sm-8 form-check form-switch d-flex align-items-center">
            <input v-model="form.isActive" id="isActive" class="form-check-input" style="cursor: pointer" type="checkbox" role="switch"  >
          </div>
        </div>

        <div class="row mt-2">
          <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
          <div class="col-sm-8">
            <Multiselect id="currency"
                         class=""
                         v-model="form.currency"
                         :options="store.getters['currencyMethods/currencies']"
                         :custom-label="(opt) => `${opt}`"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label for="method" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_method") }}</label>
          <div class="col-sm-8">
            <Multiselect id="method"
                         class=""
                         v-model.number="form.method"
                         :options="store.getters['currencyMethods/methods'](form.currency)"
                         :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                         :multiple="false"
                         select-label="Select"
                         placeholder=""
            >
              <template #option="props">
                <div class="d-flex flex-row align-items-center gap-2">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>

              <template #singleLabel="props">
                <div class="d-flex flex-row align-items-center gap-1">
                  <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                  <span>{{ helper.trans('pay_methods.' + props.option) }}</span>
                </div>
              </template>

            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-12 col-form-label  text-center text-capitalize-first">{{ helper.trans("labels.limits") }}</label>
        </div>
        <div class="row">
          <label for="dayTradesCountLimit" class="col-sm-3 col-form-label  pe-2 text-capitalize-first">{{ helper.trans("labels.daily_qty") }}</label>
          <div class="col-sm-3">
            <input v-model="form.dayTradesCountLimit"
                   v-maska
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" required class="form-control " id="dayTradesCountLimit">
          </div>
          <label for="monthTradesCountLimit" class="col-sm-3 col-form-label  ps-2 text-capitalize-first">{{ helper.trans("labels.monthly_qty") }}</label>
          <div class="col-sm-3">
            <input v-model="form.monthTradesCountLimit"
                   v-maska
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" required class="form-control " id="monthTradesCountLimit">
          </div>
        </div>
        <div class="row mt-2">
          <label for="dayTradesSumLimit" class="col-sm-3 col-form-label text-capitalize-first pe-2">{{ helper.trans("labels.daily_sum") }}</label>
          <div class="col-sm-3">
            <input v-model="form.dayTradesSumLimit"
                   v-maska
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" class="form-control " id="dayTradesSumLimit">
          </div>
          <label for="monthTradesSumLimit" class="col-sm-3 col-form-label text-capitalize-first  ps-2">{{ helper.trans("labels.monthly_sum") }}</label>
          <div class="col-sm-3">
            <input v-model="form.monthTradesSumLimit"
                   v-maska
                   data-maska="9 99#"
                   data-maska-tokens="9:[0-9]:repeated"
                   data-maska-reversed
                   type="text" class="form-control " id="monthTradesSumLimit">
          </div>
        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, computed} from "vue";
import Multiselect from "vue-multiselect";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import PayoutMethodFormDTO from "@/models/form/PayoutMethodFormDTO";
import PayMethodIcon from "@/components/PayMethodIcon.vue";

const components = {
  Multiselect,
  PayMethodIcon
}

export default defineComponent({
  name: "PayoutMethodForm",
  props: {},
  components,
  setup() {
    const store = useStore();
    const state = reactive({
      form: {} as PayoutMethodFormDTO,
    });

    const getForm = (): PayoutMethodFormDTO => {
      return state.form
    }

    const setForm = (form: PayoutMethodFormDTO) => {
      state.form = {
        ...form,
      }
    }

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
    }
  },
  async beforeMount() {
    const store = useStore();
    await store.dispatch("currencyMethods/loadList");
  }
})
</script>
